import { CSSProperties, ReactNode } from 'react'

import { Paper, Stack, Typography } from '@mui/material'

import { preview } from '@/components/form/preview'

import { useTexts } from './useTexts'

const PaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: 2,
}

interface Props {
  icon: ReactNode
  subject?: string
}

export function BackupEmailSubject(props: Props) {
  const { icon, subject } = props

  const texts = useTexts()

  return (
    <Paper elevation={0} sx={PaperStyle}>
      <preview.Field label={texts.emailBackupSubject} testId="notification-backupEmailSubject">
        <Stack direction="row" alignItems="center" spacing={1}>
          {icon}
          <Typography>{subject}</Typography>
        </Stack>
      </preview.Field>
    </Paper>
  )
}
